"use strict";

exports.__esModule = true;
exports.DebounceValue = void 0;
var _react = require("react");
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Debounce values coming from RealtimeBatchSubscription.
 */
var DebounceValue = exports.DebounceValue = /*#__PURE__*/function (_Component) {
  function DebounceValue() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      value: _this.props.value,
      firstRenderedAt: Date.now(),
      lastRenderedAt: Date.now()
    };
    return _this;
  }
  _inheritsLoose(DebounceValue, _Component);
  DebounceValue.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
    var now = Date.now();
    if ((0, _reactFastCompare["default"])(nextProps.value, prevState.value) || now - prevState.lastRenderedAt < nextProps.timeout && now - prevState.firstRenderedAt > nextProps.initialTimeout) {
      return null;
    }
    return {
      lastRenderedAt: now,
      value: nextProps.value
    };
  };
  var _proto = DebounceValue.prototype;
  _proto.render = function render() {
    return this.props.children(this.state.value);
  };
  return DebounceValue;
}(_react.Component);
DebounceValue.defaultProps = {
  initialTimeout: 10000
};